import React, { useEffect, useRef } from 'react'
import { motion as m, useScroll, useTransform, MotionValue } from 'framer-motion'
import { useParams, useNavigate } from 'react-router-dom'
import recipes from '../mockedData/recipes'
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded'
import store from '../store/store'
import RecipeDetails from '../components/RecipeDetails'

export default function Recipe() {

  const setIsMenuOpen = store((state) => state.setIsMenuOpen)

  // auto close the menu once the page is loaded
  useEffect(() => {
    setIsMenuOpen(false)
  },[])

  const navigate = useNavigate()
  const navigateBack = () => {
    navigate(-1)
  }

  // Scroll to the top of the page when the component mounts
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  let { id } = useParams()
  // Find the recipe with the matching ID
  const recipe = recipes.find(recipe => recipe.id === parseInt(id))

  // parallax method
  const ref = useRef(null) //ref the container for the parallax
  const { scrollYProgress } = useScroll({ 
    target: ref, 
    // offset: first value is the element you want to animate and the second value is the container of this element
    // so the first parameter sets the when the animation starts and the second parameter sets when the animation ends
    // offset: ["start end", "end start"], // top of the animEl meets the bottom of the container, then the bottom of the animEl meets the top of the container
    // offset: ["start start", "end start"], // top of the animEl meets the top of the container, then the bottom of the animEl meets the top of the container
    // offset: ["start 50%", "-100px start"], // top of the animEl meets the middle of the container, then the bottom of the animEl meets 100px from the top of the container
  }) 
  const imgY = useTransform(scrollYProgress, [0,1], ["0%", "-100%"])
  const overlayY = useTransform(scrollYProgress, [0,1], ["100%", "200%"])
  const titleY = useTransform(scrollYProgress, [0,1], ["3rem", "10rem"])

  const spring = {
    type: "spring",
    damping: 20,
    stiffness: 600,
  }

  const animDuration = 0.4
  
  const pageVar = { 
    initial: {
      x:'100%',
      transition: {
        duration: animDuration,
      },
    },
    animate: {
      x: '0%',
      transition: {
        duration: animDuration,
      },
    },
    exit: {
        x: '100%',
        transition: {
            duration: animDuration,
          },
    },
  }

  const recipeTextVar =  {
      initial: {
        opacity: 0,
        y:'100%',
        transition: {
          duration: animDuration,
          delay: animDuration,
        },
      },
      animate: {
        opacity: 1,
        y: '0%',
        transition: {
          duration: animDuration,
          delay: animDuration,
        },
      },
      exit: {
        opacity: 0,
          y: '100%',
          transition: {
              duration: animDuration,
            },
      },
  }

  const recipeTitleVar =  {
    initial: {
      opacity: 0,
      x:'100%',
      transition: {
        duration: animDuration,
        delay: animDuration + 0.4,
        
      },
    },
    animate: {
      opacity: 1,
      x: '0%',
      transition: {
        duration: animDuration,
        delay: animDuration + 0.4,
      },
    },
    exit: {
      opacity: 0,
        x: '100%',
        transition: {
            duration: animDuration,
          },
    },
}

  // Check if the recipe exists
  if (!recipe) {
  return <div>Recipe not found</div>
  }

  return (
    <main>
      <m.div 
        ref={ref}
        variants={pageVar} 
        initial= 'initial'
        animate= 'animate' 
        exit= 'exit'
        transition={spring} 
        id='recipe_container'
      >
        <div  id='recipe_img_container'>
          <m.img style={{ top: imgY }} id='recipe_img' src={recipe.image}  alt={recipe.title} />
          <div id='recipe_overlay'></div>
          <div 
            id='recipe_content_container' 
            variants={recipeTitleVar}
            initial='initial'
            animate= 'animate' 
            exit= 'exit'
            transition= {{delay: .8}}
          >
            <ArrowBackRoundedIcon id='back_arrow_icon' onClick={() => navigateBack()}/>
            <h2 id='recipe_content_title' /*initial= {{opacity: 0}} whileInView={{opacity: 1}} viewport={{ margin: "-300px"}}*/>
              {recipe.title}
            </h2>
          </div>
        </div>
        
        <RecipeDetails recipe={recipe}/>
      </m.div>
    </main>
  )
}
